import { Provider } from '@angular/core';
import { VOUCHER_REPOSITORY } from './application/attachments.tokens';
import { HttpVoucherRepository } from './infrastructure/http/http-voucher.repository';
import { RegisterVoucherUseCase } from './application/voucher/register-voucher.usecase';

export const ATTACHMENTS_PROVIDERS: Provider[] = [
  { provide: VOUCHER_REPOSITORY, useClass: HttpVoucherRepository },
  RegisterVoucherUseCase,
];
